<template>
 <div>
     <!-- 多选 -->
    <Select v-if="isMultiple == 1" v-model="hasChecked" ref="select"
            :filterable='filterable'
            remote
            :clearable="clearable"
            :loading="loading"
            @on-change="setVal"
            @on-clear="getData"
            :remote-method="getData"
            multiple
           :placeholder='placeholderText'
           :label-in-value='labelInValue'
    >
        <Option v-for="(item) in dataList" :disabled="item.disabled"  :label="item[labelName]+''" :value="item[valName]" :key="item[valName]" style='display:flex;align-items: center;justify-content: space-between;'><span>{{ item[labelName] }}</span>  <span v-if="labelNameNew">{{ item[labelNameNew] }}</span></Option>
    </Select>
<!-- 单选 -->
    <Select v-else-if='isMultiple == 2' ref="select"
          v-model="hasChecked"
          :filterable='filterable'
          remote
          :clearable="clearable"
          :loading="loading"
          :remote-method="getData"
          @on-change="setVal"
          @on-clear="getData"
           :placeholder='placeholderText'
           :label-in-value='labelInValue'
    >
       
       
        <Option v-for="(item) in dataList" :disabled="item.disabled" :label="item[labelName]+''" :value="item[valName]" :key="item[valName]" style='display:flex;align-items: center;justify-content: space-between;'><span>{{ item[labelName] }}</span> <span v-if="labelNameNew">{{ item[labelNameNew] }}</span></Option>
    </Select>
   <!-- 单选 允许创建 -->
    <Select v-else-if='isMultiple == 3' ref="select"
          v-model="hasChecked"
          :filterable='filterable'
          remote
          :clearable="clearable"
          :loading="loading"
          @on-change="setVal"
          @on-clear="getData"
          :remote-method="getData"
        :placeholder='placeholderText'
        @on-create="handleCreate1"
        :allow-create='allowCreate'
        :label-in-value='labelInValue'
    >
        <Option v-for="(item,index) in dataList" :disabled="item.disabled" :value="item" :key="index" style='display:flex;align-items: center;justify-content: space-between;'>{{ item }}</Option>
    </Select>
 </div>
</template>
<script>
    import common from '@/common/common.js';
    import { mapState } from 'vuex'
    export default {
        name: "selectList",
        components: {
        },
        props: {
            url: String,//接口的链接
            selectUrlQuery:{
                type:Object,
                default:()=>{}
            },
            valName: String,//传入后台的值
            labelName: String,//对外显示的说明
            isMultiple:{ //是否多选  1  多选 2单选 3 单选 直接数据
                type: [Number,String],
                default: 2
            },
            labelInValue:{//是否显示label,默认只返回 value
                type: Boolean,
                default: false
            },
            filterable:{//是否支持远程搜索。默认支持
                type: Boolean,
                default: true
            },
            keyword: { //搜索词的字段名
                type: String,
                default: ''
            },
            labelNameNew: { //备注字段
                type: String,
                default: ''
            },
            clearable:{//是否可清空
                type: Boolean,
                default: true
            },
            checkedList:{//选中的值 多选时传入数组
                type: String|Array,
                default: ''
            },
            placeholderText:{// :placeholderText="type==1?$t('selectPlaceholder'):$t('selectloadingPlaceholder')"  编辑时，没有回显显示为加载中新增时直接显示请选择
                type:[String,Number],
                default:'请输入'
            },
            index:{//操作对应的索引
                type: Number,
                default: 0
            },
            allowCreate:{
                type: Boolean,
                default: false
            },
            needName:{
                type:String,
                default:''
            },
            addAll:{
                type:String,
                default:''
            },
            listName:{
                type:String,
                default:''
            },
            hasDealerId:{//有些接口不能包含dealerId，默认为包含
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                loading:false,
                dataList:[],
                hasChecked:[],
                setValFlag:false
            }
        },
        computed:{
             ...mapState(['local','uInfo','selectId']),
        },

        created() {
        },
        mounted() {
            this.$nextTick(() => {
                if(this.checkedList.length >0){
                    this.hasChecked = this.checkedList
                }
            })

        },
        destroyed() {
        },
        methods: {
            handleCreate1(val){
                this.dataList.push(val)
            },
            getData(query){//获取列表信息,,,remote执行一次，初始执行一次
                // console.log(999999)
                // console.log('999999,query',query)
               
                let params = {}
                if(this.setValFlag){
                   params[this.valName] = query
                }else{
                   params[this.keyword] = query
                }

                let objData = {
                        ...params,
                        dealerId:this.selectId,
                        ...this.selectUrlQuery,
                    
                }
                if(this.hasDealerId==false){
                    delete objData.dealerId
                }
                // console.log('this.setValFlag',this.setValFlag)

                //  console.log('this.params',params)

                // console.log('this.selectUrlQuery',this.selectUrlQuery)
                this.loading = true;
                setTimeout(() => {

                    this.axios.post(this.url,objData).then((result) => {
                        // console.log(result.data)
                        this.loading = false;
                        //处理数组
                        // console.log('result',result)
                        if(result.data.code == 1){
                            if(this.isMultiple == 3){
                                this.dataList = result.data.data
                            }else{
                                // this.dataList = result.data.data.list != undefined?result.data.data.list: (result.data.data.dealersList !=undefined? result.data.data.dealersList: result.data.data)
                                if(!result.data.data.meta){
                                    this.dataList = result.data.data
                                }else{
                                    this.dataList = result.data.data[this.listName]
                                }
                            }

                            if(this.dataList.length==0 && this.needName){//必须有数据，不然提示请先创建数据
                                let id = this.valName
                                let val = this.labelName
                                let finallyData={};
                                finallyData[id] = ''
                                finallyData[val] = this.needName
                                finallyData['disabled'] = true
                                this.dataList.push(finallyData)
                                // common.msg('error','请先创建'+this.needName)
                            }
                            if(this.dataList.length>0 && this.addAll){//全部类别，加到第一个，好麻烦哦
                              
                                let id = this.valName
                                let val = this.labelName
                                let finallyData={};
                                finallyData[id] = '0'
                                finallyData[val] =this.$t(this.addAll)
                                this.dataList.unshift(finallyData)

                            }

                            this.setValFlag = false

                            // console.log('this.dataList',this.dataList)
                        }else{
                            common.msg('error',result.data.message,()=>{
                                this.setValFlag = false
                            })
                        }
                    }).catch((err) => {
                        // console.log(err)
                        this.loading = false;
                        this.setValFlag = false
                        // common.msg('error','获取失败',()=>{})
                    })

                }, 200);
            },
            setDefVal(val){//设置默认值
                // console.log('setDefValsetDefValsetDefValsetDefVal',val)
                this.hasChecked = val
                this.setValFlag = true
            },
            setVal(data){//子传父
                // console.log('datata',data)
                let selItem = ''
                if(data){
                    let emitval = '';
                    if(this.isMultiple == 1){
                        selItem = []
                        this.dataList.forEach((item)=>{
                            data.map((item2,index2)=>{
                                if(item[this.valName] == item2[this.valName]){
                                   selItem.push(item)
                                }
                            })
                        })
                    }else{
                        emitval = this.labelInValue?data.value:data
                        this.dataList.forEach((item)=>{
                        if(item[this.valName] == data.value){
                                selItem = item
                            }
                        })
                    }
               
                    this.$emit('setSelected', {nameVal:emitval,nowData:data,selItem:selItem})
                }else{
                    this.$emit('setSelected', {nameVal:'',nowData:{},selItem:{}})
                }

               
            },
            setQuery(key){//设置搜索词，为空时清空，仅在 filterable="true" 时有效
            //    console.log('setQuerysetQuerysetQuerysetQuery',key)

               let obj= this.$refs.select;
               obj.setQuery(key);
               this.getData()  
            },
            setValold(data){//旧的，不要了
                let nowData = ''

                if(this.isMultiple == 1){
                    nowData = []
                    this.dataList.forEach((item)=>{
                        data.map((item2,index2)=>{
                            if(item.id == item2){
                               nowData.push(item)
                            }
                        })
                    })
                }else{
                    this.dataList.forEach((item)=>{
                        if(item.id == data){
                            nowData = item
                        }
                    })
                }
                this.$emit('setSelected', data, {index:this.index,dataList:nowData})
            },
            clearVal(){
                if(this.isMultiple==1 || this.isMultiple==2){//单选时只接受 String 或 Number，多选时只接受 Array
                    this.hasChecked = ''
                }else{
                    this.hasChecked = []
                }
                this.dataList = []
            }
        }
    }
</script>
<style scoped>

  .feedbackText {
    font-size: 10px;
  }
</style>
